<template>
  <div
    class="start gradient-background"
    :class="{
      'no-start': isDisabled,
      'gradient-background': !isClick,
      'gradient-background-disabled': isClick,
    }"
    @click="into(item)"
  >
    {{ item.statusType }}
  </div>
</template>
<script>
export default {
  name: "examinationBotton",
  props: ["item"],
  data() {
    return {
      isClick: false,
    };
  },
  computed: {
    isDisabled() {
      const item = this.item;
      // 如果有待完成的问卷，允许进入问卷页面
      if (item.hasPendingQuestionnaire) {
        return false;
      }
      // 检查是否已通过考试（certPass 或 pass 均不允许再考）
      if (item.certPass || item.pass) {
        return true;
      }
      // 检查剩余考试次数（如果没有剩余次数，则禁用）
      // 但是，如果有待完成的问卷，应该允许进入问卷页面
      if (item.maxRetryTimes !== undefined && item.maxRetryTimes <= 0) {
        return true;
      }
      // 检查考试状态是否为已完成/已评分/被终止
      // 注意：如果有剩余考试机会，即使上一次考试状态是 done/graded/terminated，也应该允许重新开始考试
      // 只有在没有剩余考试机会的情况下，才因为状态而禁用
      // 但是，如果有待完成的问卷，应该允许进入问卷页面
      const hasRetryTimes = item.maxRetryTimes !== undefined && item.maxRetryTimes !== null && item.maxRetryTimes > 0;
      if (!hasRetryTimes && (item.status == 'done' || item.status == 'graded' || item.status == 'terminated')) {
        return true;
      }
      return false;
    },
  },
  methods: {
    into(item) {
      let examination = this.$storage.getStorage("examination") || [];
      let isOpen = false;
      if (examination == 1) {
        isOpen = true;
      }
      if (!isOpen) {
        // examinationList.push(item.examinationId);
        this.$emit("onClick", item);
      } else {
        this.$message.error("请勿重复进入考场，可刷新页面");
      }
      // this.$storage.setStorage([
      //   {
      //     key: "examination",
      //     value: examinationList,
      //   },
      // ]);
    },
  },
  mounted() {},
};
</script>
<style lang="less"></style>
